import { Clock } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import type { SearchItem, SearchProvider } from '../types';
import type { QueryHistoryEntry, ConnectionConfig } from '@/types';

export const historySearchProvider: SearchProvider = {
  id: 'history',
  kind: 'history',
  list: (ctx) => {
    const history = ctx.queryClient?.getQueryData<QueryHistoryEntry[]>(['queryHistory']) ?? [];
    const conns = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const connName = (id: string) => conns.find((c) => c.id === id)?.name ?? id.slice(0, 8);

    return history.map<SearchItem>((h) => {
      const snippet = h.sql.replace(/\s+/g, ' ').trim().slice(0, 80);
      return {
        id: `history:${h.id}`,
        kind: 'history',
        label: snippet + (h.sql.length > 80 ? '…' : ''),
        subtitle: `${connName(h.connectionId)} · ${h.status} · ${h.durationMs}ms`,
        icon: Clock,
        boost: 0.55,
        action: () => {
          useWorkspaceStore.getState().openTab({
            type: 'query',
            id: `query-${Date.now()}`,
            connectionId: h.connectionId,
            title: 'From History',
            sql: h.sql,
          });
        },
      };
    });
  },
};
